

export function AsterisqueRouge(){
    return(
        <span style={{color:"red"}}>*</span>
    )
}